

























































/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleModel } from "../../../Generated/ParticaAPI";
import ArticleTitle from "@/Ui-Components/Article/Common/ArticleTitle.vue";
import ArticleAbstract from "@/Ui-Components/Article/Common/ArticleAbstract.vue";
import ArticleBody from "@/Ui-Components/Article/Common/ArticleBodyV5.vue";
import ArticleSubheading from "@/Ui-Components/Article/Common/ArticleSubheading.vue";
import ArticleImages from "@/Ui-Components/Article/Common/ArticleImages.vue";

import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ICuratedArticle, IExtractedArticle } from "../../../Models/ArticleModels/article";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";
import ParticaRightDrawer from "../../Common/Container/ParticaRightDrawer.vue";



@Component(
	{
		name: "ParticaArticleEdit",
		components: {
			ArticleTitle,
			ArticleBody,
			ArticleImages,
			ParticaRowContainer,
			ArticleAbstract,
			ArticleSubheading,
			ButtonList,
			ParticaColumnContainer,
			ParticaCard,
			ParticaRightDrawer,
		}
	})
export default class ParticaArticleEdit extends Vue {
	@Prop() private article: IExtractedArticle; // your data
	@Prop() private buttons: ButtonConfig[];
	@Prop() private title: string;
	private active: number = 0;

	@Prop() private value: boolean;
	private display: boolean = false;
	@Watch("value")
	private watcher() {
		this.display = this.value;
	}
	@Watch("display")
	private update() {
		this.$emit("input", this.display);
	}

	private buttonClicked(clicked: ParticaEvent) {
		this.$emit("partica-event", clicked);
	}

	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}

	private keyboard(val: string, event: any) {
		switch (val) {
			case "SAVE": {
				this.$emit("partica-event", { action: eParticaAction.ARTICLE_SAVE } as ParticaEvent);
				this.$nextTick(() => {
					event.srcElement.focus(); // keep focus in the input that generated the event
				});
				break;
			}
			case "CLOSE": {
				this.$emit("close", {} as ParticaEvent);
				break;
			}
		}
	}
}
